import { computed } from 'vue';
import { AuthenticationProviderType } from '@/domain/enums/authentication-provider-type';
import Actions from '@/dictionary/tracking/actions';
import { IIncentiveV2Store } from '@/domain/dto/store.incentive-v2.interfaces';
import { SocialIncentiveButtonsBase } from '../SocialIncentiveButtonsBase.class';

export default class LinkedInSigninButton extends SocialIncentiveButtonsBase {
	public pending = computed((): boolean => {
		return false;
	});

	public template: string;

	protected readonly buttonName = 'LinkedInButton';

	constructor(protected store: IIncentiveV2Store, isRegistration: boolean, template = 'Small') {
		super(store, isRegistration);

		this.template = template;
	}

	public async authenticate(): Promise<void> {
		await this.signInWithProvider({
			provider: AuthenticationProviderType.LINKEDIN,
		});
		this.trackButtonClick(Actions.LINKEDIN_BUTTON_CLICK);
	}
}
